import React, { ReactNode } from "react";
import { Link , HelpPanel} from "@cloudscape-design/components";

export interface SentinelInfoSectionProps {
    children: ReactNode;
    header: string;
    link?: string;
  }
  
  const Footer: React.FC<{ href: string }> = ({ href }) => (
    <h3>
      <Link
        href={href}
        external={true}
        externalIconAriaLabel="Opens in a new tab"
      >
        Learn more
      </Link>
    </h3>
  );
  
  export const SentinelInfoSection: React.FC<SentinelInfoSectionProps> = (props) => {
    const toolsFooter = (
      <Footer
        href={
          props?.link ?? "https://w.amazon.com/bin/view/DependencySentinel"
        }
      />
    );
  
    return (
      <HelpPanel footer={toolsFooter} header={<h2> {props.header}</h2>}>
        {props.children}
      </HelpPanel>
    );
  };